import React, { Component } from 'react';
import { Routes, Route } from "react-router-dom";
import {
    Landing,
    DashboardRdg,
    PrestataireRcg,
    AgentGrdfRcg,
    GridProcess,
    Shipping,
    ManageUsers,
} from "./_pages";
import { RequiredAuth } from "./secureRoute";
import { RequiredRole } from "./_components/shared";

const RDG_ROLES = ['ROLE_RDG'];
const RCG_ROLES = ['ROLE_RCG_PRESTA', 'ROLE_AGENT_GRDF'];

export default class AppRoutes extends Component {
    render = () => <Routes>
        <Route exact={true} path='' element={<RequiredAuth />}>
            <Route path="" element={<Landing/>}/>
        </Route>

        <Route exact={true} path='/rdg' element={<RequiredAuth />}>
            <Route element={<RequiredRole allowedRoles={RDG_ROLES} />}>
                <Route path="" element={<DashboardRdg/>}/>
            </Route>
        </Route>
        <Route exact={true} path='/rdg/traiter-grille' element={<RequiredAuth />}>
            <Route element={<RequiredRole allowedRoles={RDG_ROLES} />}>
                <Route path="" element={<GridProcess/>}/>
            </Route>
        </Route>
        <Route exact={true} path='/rdg/expedier' element={<RequiredAuth />}>
            <Route element={<RequiredRole allowedRoles={RDG_ROLES} />}>
                <Route path="" element={<Shipping/>}/>
            </Route>
        </Route>

        <Route exact={true} path='/rcg' element={<RequiredAuth />}>
            <Route element={<RequiredRole allowedRoles={RCG_ROLES} />}>
                <Route path="" element={<PrestataireRcg/>}/>
            </Route>
        </Route>
        <Route exact={true} path='/rcg/prestataire-rcg' element={<RequiredAuth />}>
            <Route element={<RequiredRole allowedRoles={RCG_ROLES} />}>
                <Route path="" element={<PrestataireRcg/>}/>
            </Route>
        </Route>
        <Route exact={true} path='/rcg/agent-grdf' element={<RequiredAuth />}>
            <Route element={<RequiredRole allowedRoles={['ROLE_AGENT_GRDF']} />}>
                <Route path="" element={<AgentGrdfRcg/>}/>
            </Route>
        </Route>

        <Route exact={true} path='/manage-users' element={<RequiredAuth />}>
            <Route element={<RequiredRole allowedRoles={['ROLE_AGENT_GRDF']} />}>
                <Route path="" element={<ManageUsers/>}/>
            </Route>
        </Route>
    </Routes>
}
